export enum PuzzleInputMode {
    mainDigit,
    cornerDigit,
    centerDigit,
    color,
    lines,
    move,
    quads,
    custom,
    shading,
}
